export const LINKS = [
  {
    icon: 'menu-builder',
    text: 'Drag and drop to build',
    title: 'Website Builder',
    to: '/website-builder',
  },
  {
    icon: 'menu-store',
    text: 'Add products and sell',
    title: 'Online Store',
    to: '/online-store',
  },
  {
    icon: 'menu-manager',
    text: 'Your brand your way',
    title: 'Customer Manager',
    to: '/customer-manager',
  },
  {
    icon: 'menu-integration',
    text: 'cPanel, WHMCS or API',
    title: 'Simple Integration',
    to: '/simple-integration',
  },
];
